<template>
  <b-form-group
    :label="label">
    <b-form-input
      :ref="`ref${name}`"
      :type="type"
      :name="name"
      :placeholder="placeholder"
      :disabled="disabled"
      :state="verificaEstadoInput()"
      :min="valMin"
      :max="valMax"
      v-model="valor"
      @input="onStateInput($event, 'onInput')"
      @change="onStateInput($event, 'onChange')"
      @update="onStateInput($event, 'onUpdate')"
      @blur="$emit('blur')"
      autocomplete="off"
    />
    <b-form-invalid-feedback>
      {{ retornaMensagemDeErro() }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import bFormGroup from 'bootstrap-vue/es/components/form-group/form-group'
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input'
import bFormInvalidFeedback from 'bootstrap-vue/es/components/form/form-invalid-feedback'
import InputBaseMixins from './mixins/InputBaseMixins'


export default {
  name: 'InputBasico',
  mixins: [InputBaseMixins],
  props: {
    type: {
      required: true,
    },
  },
  components: {
    bFormGroup,
    bFormInput,
    bFormInvalidFeedback,
  },
}

</script>
